module.exports = __webpack_public_path__ + "static/media/ved_dandekar.f9424368.jpg";